import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  accordionHeader: {
    background: theme.palette.darkGrey[2],
    alignItems: 'center',
    display: 'flex',
    padding: `0 ${theme.typography.pxToRem(32)}`,
    width: '100%',
  },
  accordionAreaAction: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${theme.typography.pxToRem(22)} 0`,
    width: '100%',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  labelSection: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightMedium as number,
  },
  labeDisabled: {
    color: theme.palette.darkGrey[50],
  },
  endIconRotate: {
    transform: 'rotate(180deg)',
  },
}));

export default useStyles;
